export interface PaginationRequest {
  offsetId?: number;
  page?: number;
  fetch?: number;
  legalEntityCode?: string | number;
}
